import * as React from "react";
import type { SVGProps } from "react";
const SvgCityjet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#781520"
      d="M47.955 6H19.02L2 17.902h28.091l.01-.005L18.892 44l17.548-11.082L48 6z"
    />
  </svg>
);
export default SvgCityjet;
